import { useContext } from "react";
import { RecaptchaContext, RecaptchaContextType } from "./re-captcha-provider";
export type UseReCaptcha = {
  /**
   * Used to manually trigger an audit of the current session.
   *
   * Returns a token that can be sent to the server to determine the user's trust score.
   *
   * @example
   * const reCaptcha = useReCaptcha("Login-Form-Submit");
   *
   * function handleSubmit(): Promise<void> {
   *  try {
   *    const result = await reCaptcha.execute();
   *    // If an action was not passed to useReCaptcha we could pass one now
   *    // reCaptcha.execute("Login-Form-Submit")
   *    if(result.isError) return await logException(result.error)
   *    await fetch(url, {
   *      method: "POST",
   *      data: JSON.stringify({
   *        reCaptchaToken: result.value
   *      })
   *    })
   *  } catch(error) {
   *    await logException(error)
   *  }
   * }
   */
  execute: RecaptchaContextType["execute"];
  onLoad: RecaptchaContextType["onLoad"];
};
export function useReCaptcha(): UseReCaptcha {
  const recaptcha = useContext(RecaptchaContext);
  if (!recaptcha) {
    throw new Error('"useReCaptcha" can only be used within a <ReCaptchaProvider>');
  }
  return recaptcha;
}